import React from 'react';
import { Form, FormGroup } from "reactstrap";
import InputCustom from "../../../../components/InputCustom";
import LoadingButton from "../../../../components/LoadingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

const RegisterForm = ({ intl, values, isLoading, isSuccess, registerFailed, handleChange, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <InputCustom
          required
          id="register-firstname"
          name="firstName"
          value={values.firstName}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'RegisterForm.firstName' })}
        />
      </FormGroup>

      <FormGroup>
        <InputCustom
          required
          id="register-lastname"
          name="lastName"
          value={values.lastName}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'RegisterForm.lastName' })}
        />
      </FormGroup>

      <FormGroup>
        <InputCustom
          required
          id="register-email"
          name="email"
          type="email"
          value={values.email}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'RegisterForm.email' })}
        />
      </FormGroup>

      <FormGroup>
        <InputCustom
          required
          id="register-password"
          name="password"
          type="password"
          value={values.password}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'RegisterForm.password' })}
        />
      </FormGroup>

      <FormGroup>
        <InputCustom
          required
          id="register-passwordrepeat"
          name="passwordRepeat"
          type="password"
          value={values.passwordRepeat}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'RegisterForm.rePassword' })}
        />
      </FormGroup>

      <div className="text-center">
        <LoadingButton
          isLoading={isLoading}
          isSucceed={isSuccess}
          isFailed={registerFailed}
          value="RegisterForm.createAccount"
          type="submit"
          className="btn btn-outline-light btn-block btn-login"
        />
      </div>
      <div className="mt-2 text-center">
        <Link to="/login" className="text-white">
          <FontAwesomeIcon icon={faArrowLeft} className="mr-1" />
          <FormattedMessage id="RegisterForm.back" />
        </Link>
      </div>
    </Form>
  );
};

export default injectIntl(RegisterForm);
